import PropTypes from 'prop-types';
import { addAlert } from '../../../../common/actions/alerts';
import { connect } from '../../../../common/react-redux';
import { RetryGradePassbackButton as RetryGradePassbackButtonPresenter } from './presenter';
var mapStateToProps = function mapStateToProps(state) {
  return {};
};
var mapDispatchToProps = {
  addAlert: addAlert
};
var ConnectedRetryGradePassbackButton = connect(mapStateToProps, mapDispatchToProps)(RetryGradePassbackButtonPresenter);

// Note: We don't want to expose props that are only used internally by the container component
export var RetryGradePassbackButton = ConnectedRetryGradePassbackButton;
RetryGradePassbackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  'data-automation': PropTypes.string
};